
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const PayPal = forwardRef((props, ref) => {

    return (
        <React.Fragment>        
            <PayPalScriptProvider options={{ "client-id": props.client_paypal }}>
                <PayPalButtons
                    createOrder={(data, actions) => {
                        return actions.order.create({
                            intent: "CAPTURE",
                            purchase_units: [
                                { 
                                    amount: { 
                                        currency_code: props.price.currency.code,
                                        value: props.prices.paypal 
                                    },

                                    reference_id: `${props.reference}, ${props.customerData.user_platform_id}, ${props.customerData.price_id}, ${props.customerData.affiliate_id ? props.customerData.affiliate_id : null }, ${props.customerData.discount_code_id ? props.customerData.discount_code_id : null}`,
                                }
                            ],
                        });
                    }}
                    onApprove={(data, actions) => {
                        return actions.order.capture().then((details) => {
                            if(details.status == "COMPLETED"){
                                props.toogleTab("payment_completed")
                            }
                        });
                    }}
                />
            </PayPalScriptProvider>
        </React.Fragment>
    );
});


export default PayPal;